"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_i18next_1 = require("react-i18next");
const AdminHomePage = (props) => (react_1.default.createElement("div", { className: "admin" },
    react_1.default.createElement("div", { className: "survey-section__content apptr__form-container" },
        react_1.default.createElement("h2", null, props.t('menu:home')),
        react_1.default.createElement("ul", null, props.user &&
            props.user.pages.map((page) => (react_1.default.createElement("li", { className: "tr__top-menu-element", key: `item-${page.title}` },
                react_1.default.createElement(react_router_1.NavLink, { className: "menu-button", key: page.title, to: page.path }, props.t(page.title)))))))));
const mapStateToProps = (state) => {
    return { user: state.auth.user };
};
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_i18next_1.withTranslation)('menu')(AdminHomePage));
//# sourceMappingURL=AdminHomePage.js.map